import Vue from 'vue'
import App from '@/App.vue'

// api
import '@/shared/services/api'

// store
import store from '@/shared/store'

// router
import router from './router'

// plugins
import '@/shared/plugins'

// layout AdminLTE
import './shared/layouts/adminlte'

// filters
import '@/shared/common/filters'

// info de deploy (log no console em dev/homolog)
import './common/helpers/deployInfo'

import '@/shared/assets/css/main.scss'

// Configurações do módulo
Vue.prototype.$urlBase = '/contabilidade'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
